import EventManager, { EventType } from '../utilities/EventManager';

export const LayoutDelegate = () => {
  return Class => {
    return class extends Class {
      constructor(props) {
        super(props);
      }

      componentDidMount() {
        super.componentDidMount();

        EventManager.addEventListener(EventType.LAYOUT_UPDATE, () => {
          this.setState({ layout: Math.random() });
          this.forceUpdate();
        });
      }
    };
  };
};



// WEBPACK FOOTER //
// ./src/utilities/LayoutDelegate.js